<!--
=========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================
-->

<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" :key="$route.fullPath"/>
    <idle-tracking v-if="isLogged"/>
    <ApiErrorModal />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import themeConfig from '../themeConfig';

import IdleTracking from '@/febos/global/_vue/componentes/IdleTracking';
import ApiErrorModal from '@/febos/global/_vue/componentes/ApiErrorModal';

export default {
  components: {
    ApiErrorModal,
    IdleTracking
  },
  data() {
    return {
      vueAppClasses: []
    };
  },
  watch: {
    '$store.state.theme': function (val) {
      this.toggleClassInBody(val);
    },
    '$vs.rtl': function (val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr');
    }
  },
  computed: {
    ...mapGetters('Usuario', [
      'isLogged'
    ])
  },
  methods: {
    toggleClassInBody(className) {
      switch (className) {
        case 'dark': {
          if (document.body.className.match('theme-semi-dark')) {
            document.body.classList.remove('theme-semi-dark');
          }
          document.body.classList.add('theme-dark');
          break;
        }

        case 'semi-dark': {
          if (document.body.className.match('theme-dark')) {
            document.body.classList.remove('theme-dark');
          }
          document.body.classList.add('theme-semi-dark');
          break;
        }

        default: {
          if (document.body.className.match('theme-dark')) {
            document.body.classList.remove('theme-dark');
          }
          if (document.body.className.match('theme-semi-dark')) {
            document.body.classList.remove('theme-semi-dark');
          }
          break;
        }
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth);

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    },
    handleScroll() {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY);
    }
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth);

    const vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    const favicon = document.getElementById('favicon');
    favicon.href = favicon.href.replace('favicon_febos.png', `favicon_${process.env.VUE_APP_PRODUCTO}.png`);
  },
  async created() {
    const dir = this.$vs.rtl ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);

    window.addEventListener('resize', this.handleWindowResize);
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener('scroll', this.handleScroll);
  }
};

</script>
